import { WebApiReduxRequest, WebApiReduxRequestWithCallback, HTTP_GET, HTTP_POST } from "tools/webservice";
import { api } from "apis/underwriterActions";
import {
  REQUEST_ADD_CUSTOMER_ACTION,
  SUCCESS_ADD_CUSTOMER_ACTION,
  ERROR_ADD_CUSTOMER_ACTION,

  REQUEST_GET_CUSTOMER_ACTIONS,
  SUCCESS_GET_CUSTOMER_ACTIONS,
  ERROR_GET_CUSTOMER_ACTIONS,

  REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER,
  RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER,
  ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER,
} from "typeConstants";
import { getCaseInfo } from "actions/customer";

const addCustomerAction = (action) => WebApiReduxRequestWithCallback(
  REQUEST_ADD_CUSTOMER_ACTION,
  SUCCESS_ADD_CUSTOMER_ACTION,
  ERROR_ADD_CUSTOMER_ACTION,
  HTTP_POST,
  api.addCustomerAction(),
  () => getCustomerActions(action.controlNumber),
  action,
);

const getCustomerActions = controlIdNumber => WebApiReduxRequest(
  REQUEST_GET_CUSTOMER_ACTIONS,
  SUCCESS_GET_CUSTOMER_ACTIONS,
  ERROR_GET_CUSTOMER_ACTIONS,
  HTTP_GET,
  api.getCustomerActions(controlIdNumber),
);

const markReviewed = (action) => WebApiReduxRequestWithCallback(
  REQUEST_ADD_CUSTOMER_ACTION,
  SUCCESS_ADD_CUSTOMER_ACTION,
  ERROR_ADD_CUSTOMER_ACTION,
  HTTP_POST,
  api.markReviewed(),
  () => getCaseInfo(action.controlNumber),
  action,
  () => getCaseInfo(action.controlNumber),
);

const getAllCustomerActionsForUser = () => WebApiReduxRequest(
  REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER,
  RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER,
  ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER,
  HTTP_GET,
  api.getAllCustomerActionsForUser(),
);

export {
  addCustomerAction,
  getCustomerActions,
  markReviewed,
  getAllCustomerActionsForUser,
};